/** iPhone или iPad. iPadOS представляется Mac, но с сенсорным экраном. */
export function isIos(): boolean {
  const ua = navigator.userAgent
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1)
}

/** Приложение открыто как установленное (с экрана «Домой» или из списка приложений). */
export function isStandalone(): boolean {
  const nav = navigator as Navigator & { standalone?: boolean }
  return nav.standalone === true || window.matchMedia?.('(display-mode: standalone)').matches
}

/**
 * Иконка устройства по его названию из списка сессий и подписок («Chrome, Android»,
 * «Яндекс Браузер, Windows»): телефон, планшет или компьютер. Неизвестное считаем телефоном,
 * приложение в основном открывают с него.
 */
export function deviceIcon(label: string | null | undefined): string {
  if (!label) return 'pi-mobile'
  if (/\biPad\b/.test(label)) return 'pi-tablet'
  if (/\b(Windows|macOS|Linux)\b/.test(label)) return 'pi-desktop'
  return 'pi-mobile'
}
